import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'

export enum VerifyNotificationStatusEnum {
  Pending = 'pending',
  Error = 'error',
  Success = 'success',
}

/**
 * GbVerifyNotificationStatusService
 * This service is responsible for setting and exposing the notification verification status
 * The status is set via the auth effects and is exposed to the gb-verfication-component to
 * display the correct messages.
 */
@Injectable({
  providedIn: 'root',
})
export class GbVerifyNotificationStatusService {
  nVStatusSubject$ = new BehaviorSubject<VerifyNotificationStatusEnum | null>(null)
  nVStatus$: Observable<VerifyNotificationStatusEnum | null> = this.nVStatusSubject$.asObservable()

  nVSuccess() {
    this.nVStatusSubject$.next(VerifyNotificationStatusEnum.Success)
  }
  nVError() {
    this.nVStatusSubject$.next(VerifyNotificationStatusEnum.Error)
  }
  nVPending() {
    this.nVStatusSubject$.next(VerifyNotificationStatusEnum.Pending)
  }
  nVClear() {
    this.nVStatusSubject$.next(null)
  }
}
